import { useCallback } from "react";
import { useHistory } from 'react-router-dom';

import routes from '@/common/routes';
import { useMyMoneyStore } from '@/modules/UseMyMoney/stores';
import { ClaimSummaryField, UseMyMoneyStep } from '@/modules/UseMyMoney/UseMyMoney.types';

export const UseMyMoneyStepPath = {
  [UseMyMoneyStep.SELECT_OPTION]: routes.USE_MY_MONEY,
  [UseMyMoneyStep.READY_TO_SCAN]: routes.USE_MY_MONEY_READY_TO_SCAN,
  [UseMyMoneyStep.SUMMARY]: routes.USE_MY_MONEY_SUMMARY,
};

export const useMyMoneyNavigation = () => {
  const history = useHistory();
  const {
    employeeId,
    setUseMyMoneyStep,
    activeField,
    setActiveField,
  } = useMyMoneyStore();

  const handleSetStep = useCallback((newStep: UseMyMoneyStep, id?: string) => {
    setUseMyMoneyStep(newStep);
    const stepRoute = UseMyMoneyStepPath?.[newStep];
    if (stepRoute) {
      history.replace(stepRoute(id ?? employeeId));
    }
  }, [history, setUseMyMoneyStep, employeeId]);

  const navigateToSelectOption = useCallback((id?: string) => {
    handleSetStep(UseMyMoneyStep.SELECT_OPTION, id);
  }, [handleSetStep]);

  const navigateToReadyToScan = useCallback(() => {
    handleSetStep(UseMyMoneyStep.READY_TO_SCAN);
  }, [handleSetStep]);

  const navigateToSummary = useCallback(() => {
    handleSetStep(UseMyMoneyStep.SUMMARY);
  }, [handleSetStep]);

  const handleSetActiveField = useCallback((activeField?: ClaimSummaryField) => {
    if (activeField) {
      setActiveField(activeField);
      history.replace(routes.USE_MY_MONEY_SETUP_FIELDS(employeeId));
      return;
    }

    setActiveField(activeField);
    history.replace(routes.USE_MY_MONEY_SUMMARY(employeeId));
  }, [history, employeeId, setActiveField]);

  return {
    handleSetStep,
    navigateToSelectOption,
    navigateToReadyToScan,
    navigateToSummary,
    activeField,
    handleSetActiveField,
  };
};
